import { ChallengeScheme, CoorporateScheme, UserScheme } from "client-v2";
import { TextArea, ColorV2 } from "@adoptaunabuelo/react-components";
import { ReactNode, useEffect, useState } from "react";
import Footer from "../../../views/letter/section/Footer";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import SectionContainer from "../../container/SectionContainer";

const Letter = (
	props: LetterProps &
		(
			| { grandpa: UserScheme; challenge?: undefined }
			| { challenge: ChallengeScheme; grandpa?: undefined }
		)
) => {
	const colors =
		props.corporate && props.corporate.color
			? {
					buttonBackground: props.corporate.color.main,
					buttonColor: props.corporate.color.third,
					animation: [
						props.corporate.color.main,
						props.corporate.color.secondary,
					],
			  }
			: {
					buttonBackground: ColorV2.surface.primary,
					buttonColor: "white",
					animation: ["#00315C", "#005AA8"],
			  };
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const translation = useSelector(
		(state: State) => state.location.translation
	);
	const [letter, setLetter] = useState<string | undefined>(undefined);

	useEffect(() => {
		setLetter(props.defaultValue);
	}, [props.defaultValue]);

	const onNextClick = () => {
		if (letter && letter.length <= 0)
			props.onFinish({
				error: translation.component_input_letter_error_01,
			});
		else {
			if (!letter || letter.length <= 50)
				props.onFinish({
					error: translation.component_input_letter_error_02,
				});
			else if (letter && letter.length >= 16384)
				props.onFinish({
					error: translation.component_input_letter_error_03,
				});
			else
				props.onFinish({
					data: letter,
				});
		}
	};

	return (
		<SectionContainer
			title={props.title}
			subtitle={props.subtitle}
			style={{
				paddingTop: props.title && 0,
			}}
			childrenProps={{
				style: {
					flex: 1,
					margin: props.title
						? isMobile
							? "24px -24px 0px"
							: "32px 0px 0px"
						: isMobile
						? "0px"
						: "0px",
				},
			}}
			footerStyle={{ margin: "unset" }}
			buttonProps={{
				LeftView: isMobile && props.grandpa && (
					<Footer
						grandpa={props.grandpa}
						corporate={props.corporate}
					/>
				),
				style: {
					color: colors.buttonColor,
					backgroundColor: colors.buttonBackground,
					margin: isMobile ? "unset" : "24px",
				},
				backgroundColor: isMobile
					? ColorV2.surface.background
					: "white",
				padding: isMobile && "8px 24px",
				disabled: letter && letter.length > 0 ? false : true,
				children: translation.component_button_next,
				onClick: onNextClick,
			}}
		>
			<TextArea
				style={{
					height: isMobile ? "calc(var(--doc-height) - 72px - 58px)" : "calc(var(--doc-height) - 72px - 104px - 16px)",
					width: "100%",
					borderRadius: isMobile ? 0 : "12px 12px 0px 0px",
					backgroundColor: "white",
					
				}}
				type="edit"
				placeholder={
					props.challenge
						? "Escribe tu felicitación"
						: "Escribe tu carta"
				}
				value={props.defaultValue}
				ToolbarButton={props.TipButton}
				onChange={(value) => {
					const prevLetterString =
						localStorage.getItem("letter") || "{}";
					const prevLetter = JSON.parse(prevLetterString);
					localStorage.setItem(
						"letter",
						JSON.stringify({
							...prevLetter,
							content: value,
						})
					);
					setLetter(value);
				}}
			/>
		</SectionContainer>
	);
};
export default Letter;
export interface LetterProps {
	title?: string;
	subtitle?: string;
	user: UserScheme;
	corporate?: CoorporateScheme;
	defaultValue?: string;
	TipButton?: ReactNode;
	onFinish: (result: { data?: string; error?: string }) => void;
}
